import { css } from 'lit'
import {
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText,
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseDefinitionListItem = {
  borderColor: css`var(--cse-definition-list-item-border-color, ${csColorBorder.light})`,
  color: css`var(--cse-definition-list-item-color, ${csColorText.body})`,
  evenBackgroundColor: css`var(--cse-definition-list-item-even-background-color, ${csColorBackground.secondary})`,
  oddBackgroundColor: css`var(--cse-definition-list-item-odd-background-color, ${csColorBackground.primary})`,
  paddingInline: css`var(--cse-definition-list-item-padding-x, ${csSpacing.spacing05})`,
  paddingBlock: css`var(--cse-definition-list-item-padding-y, ${csSpacing.spacing05})`,

  infoColor: css`var(--cse-definition-list-item-info-color, ${csColorFunctional.info})`,
  placeholderIconDisplay: css`var(--cse-definition-list-item-placeholder-icon-display, inline-flex)`,
}


export const listStyle = css`
  .cse-definition-list {
    width: 100%;
  }
`

export const definitionListItemStyle = css`
  :host {
    --cse-text-gap: ${csSpacing.spacing04};
  }

  .cse-definition-list-item {
    --cse-text-color: ${cseDefinitionListItem.color};
    border-width: ${csBorder.width};
    border-style: solid;
    border-color: ${cseDefinitionListItem.borderColor};
    padding-block: ${cseDefinitionListItem.paddingBlock};
    padding-inline: ${cseDefinitionListItem.paddingInline};
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  :host([data-definition-odd]) .cse-definition-list-item {
    background-color: ${cseDefinitionListItem.oddBackgroundColor};
  }

  :host([data-definition-even]) .cse-definition-list-item {
    background-color: ${cseDefinitionListItem.evenBackgroundColor};
  }

  :host(:not([data-definition-first])) .cse-definition-list-item {
    margin-top: calc(-1 * ${csBorder.width});
  }

  cse-tooltip {
    display: flex;
  }

  [icon-role="cse-definition-list-item.info"] {
    color: ${cseDefinitionListItem.infoColor};
  }

  .hidden-icon {
    opacity: 0;
  }

  .hidden-icon:not([icon-hidden]) {
    display: ${cseDefinitionListItem.placeholderIconDisplay};
  }
`
